import * as React from "react";
import Modal from "../../Modal";
import SimpleButton from "../../RenderComponents/SimpleButton";
import Share from "../Share";

interface IProps {
    className?: string;
    type?: "a" | "button";
    text?: string;
    title?: string;
    ariaLabel?: string;
    showIcon?: boolean;
}

const ShareButton = ({ className, type, text, title, ariaLabel, showIcon }: IProps) => {
    const [isShareOpen, setIsShareOpen] = React.useState<boolean>(false);
    return (
        <>
            <SimpleButton
                className={className || "CMS_button CMS_bSimple"}
                type={type}
                title={title}
                ariaLabel={ariaLabel}
                href={"#"}
                onClick={(e) => {
                    e.preventDefault();
                    setIsShareOpen(true);
                }}
            >
                {showIcon ? <em className="fa fa-share-alt" aria-hidden="true"></em> : null} {text || "Share"}
            </SimpleButton>
            <Modal isOpen={isShareOpen} isClosable={false} style={{ background: "red" }}>
                <Share onClose={() => setIsShareOpen(false)} />
            </Modal>
        </>
    );
};

export default ShareButton;
